'use client'

import { useSetMarketingBannerVisible } from '@/feature/marketing/services/marketing.cookies.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import type { AnnouncementBarProps } from '@/ui/announcement-bar/AnnouncementBar.client'
import { AnnouncementBar } from '@/ui/announcement-bar/AnnouncementBar.client'
import { useCallback } from 'react'

export function MarketingBannerClient(
  props: StrictOmit<AnnouncementBarProps, 'onClose'>,
): React.ReactElement | null {
  const { isVisible, setMarketingBannerVisible } = useSetMarketingBannerVisible()

  const handleClose = useCallback(() => {
    setMarketingBannerVisible(false)
    pushToGtmDataLayer({
      event: 'gaEvent',
      eventCategory: 'top header',
      eventAction: 'clic bandeau marketing',
      eventLabel: 'fermer le bandeau',
    })
  }, [setMarketingBannerVisible])

  if (!isVisible) {
    return null
  }

  return <AnnouncementBar {...props} onClose={handleClose} />
}
